import React from 'react';
import { useLocation } from 'react-router-dom';
import EmailVerification from '../components/EmailVerification';
import Header from '../components/Header';

const VerifyEmailPage = () => {
  const location = useLocation();
  const { email, password } = location.state || {};

  return (
    <>
      <Header />
      <div className="app-container">
        <div className="left-image">
          <img src="/image.png" alt="Invoices Illustration" />
        </div>
        <EmailVerification email={email} password={password} />
      </div>
    </>
  );
};

export default VerifyEmailPage;
